'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = intersection;
function intersection(array) {
  for (var _len = arguments.length, restArrays = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    restArrays[_key - 1] = arguments[_key];
  }

  var result = [];

  array.forEach(function (entry) {
    if (result.includes(entry)) {
      return;
    }
    if (restArrays.every(function (arr) {
      return arr.includes(entry);
    })) {
      result.push(entry);
    }
  });

  return result;
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/self-service-api/static-1.837/js/core/utilities/arrayIntersection.js
// module id = 523
// module chunks = 3 4 5